import { render, staticRenderFns } from "./ExSubscriptionStatusBadge.vue?vue&type=template&id=9a159d42"
import script from "./ExSubscriptionStatusBadge.vue?vue&type=script&lang=js"
export * from "./ExSubscriptionStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./ExSubscriptionStatusBadge.vue?vue&type=style&index=0&id=9a159d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports